module.exports = __webpack_public_path__ + "img/autografika.9da9289b.jpg";